<template>
<div>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-card no-body
                :header="DisplayPersonal" header-bg-variant="dark" header-text-variant="light">
            <b-list-group v-for="item in DisplayCargoPersonal" :key="item.Id" flush>
                <b-list-group-item>{{item.DisplayInfoCargoEstablecimiento}}</b-list-group-item>
            </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col cols="12">
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form v-if="true" enctype="multipart/form-data" @submit.stop.prevent="handleSubmit(onSubmit)">
            <b-form-row v-if="notEmptyObject(this)">
              <b-col cols="12">
                <card-datos-contacto :personal="this.personal"></card-datos-contacto>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="6">
                <validation-provider name="tipoSolicitud" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group
                    id="inputTipoSolicitud-group"
                    label="Tipo de solicitud:"
                    label-for="inputTipoSolicitud"
                  >
                    <b-form-select v-model="inputTipoSolicitudSelected" :options="inputTipoSolicitud.options.filter(s => personal.DisplaySexo !== 1 ? s.value !== 5 : true)"></b-form-select>
                  </b-form-group>
                  <b-form-invalid-feedback id="inputTipoSolicitud-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <p v-if="explicacionArticulo.map(item => item.Id).includes(inputTipoSolicitudSelected)">
                  {{explicacionArticulo.find(item => item.Id === inputTipoSolicitudSelected).Descripcion}}
                  <a :href="explicacionArticulo.find(item => item.Id === inputTipoSolicitudSelected).Link" target="_blank">Más información</a>
                </p>
                <validation-provider name="tipoContagio" :rules="{ required: false }" v-slot="validationContext">
                  <b-form-group
                    v-if="inputTipoSolicitudSelected === 2"
                    id="inputTipoContagio-group"
                    label="Tipo de contagio:"
                    label-for="inputTipoContagio"
                  >
                    <b-form-select v-model="inputTipoContagioSelected" :options="inputTipoContagio.options"></b-form-select>
                  </b-form-group>
                  <b-form-invalid-feedback id="inputTipoContagio-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="6">
                <validation-provider name="fechaDesde" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="inputFechaDesde-group" label="Ausente desde" label-for="inputFechaDesde">
                    <b-form-datepicker
                      locale="es"
                      id="inputFechaDesde"
                      v-model="inputFechaDesde.value"
                      placeholder="Ausente desde"
                      :disabled="disabled"
                      :min="inputFechaDesde.min"
                      :max="inputFechaDesde.max"
                      :state="checkForm(validationContext)"
                    ></b-form-datepicker>
                    <b-form-invalid-feedback id="inputFechaDesde-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col>
              <validation-provider v-if="true" name="cantidadDias" :rules="{ required: false }" v-slot="validationContext">
                <b-form-group
                  v-if="inputTipoSolicitudSelected === 6"
                  id="inputCantidadDias-group"
                  label="Cantidad de días solicitados:"
                  label-for="inputCantidadDias"
                >
                  <b-form-input
                    id="inputCantidadDias"
                    type="number"
                    min="0"
                    v-model="inputCantidadDias"
                    :disabled="disabled"
                    :state="checkForm(validationContext)"
                  />
                </b-form-group>
                <b-form-invalid-feedback id="inputCantidadDias-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <validation-provider v-if="true" name="observaciones" :rules="{ required: true }" v-slot="validationContext">
                <b-form-group id="inputObservaciones-group" label="Observaciones :" label-for="inputObservaciones">
                  <b-form-textarea
                    id="inputObservaciones"
                    v-model="inputObservaciones"
                    placeholder=""
                    rows="3"
                    max-rows="6"
                    :disabled="disabled"
                    :state="checkForm(validationContext)"
                  ></b-form-textarea>
                  </b-form-group>
                  <b-form-invalid-feedback id="inputCantidadDias-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>

              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <validation-provider name="adjunto" :rules="{ required: ([0,1,2,3,4,5].includes(inputTipoSolicitudSelected) ? false : true), ext: ['jpg', 'jpeg', 'jfif', 'png', 'pdf'], size: 1024 }" v-slot="validationContext">
                  <b-form-group id="inputAdjunto-group" label="Adjuntar archivo" label-for="inputAdjunto">
                    <b-form-file
                      class="mb-2"
                      v-model="inputAdjunto"
                      placeholder="Archivos permitidos: jpg, jpeg, jfif, png, pdf"
                      drop-placeholder="Suelte el archivo aquí..."
                      :state="checkForm(validationContext)"
                    ></b-form-file>
                    <b-button v-if="inputAdjunto" @click="inputAdjunto = null">Remover archivo </b-button>
                  </b-form-group>
                </validation-provider>
                <p style="margin-top: -10px; color: red;"
                    v-if="archivoPesoAdvetencia">
                  El tamaño del archivo no debe superar 1MB.
                </p>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col class="text-right">
                <b-button :disabled="disabled" class="mb-2" variant="warning" v-on:click="cerrarFormulario()">Cancelar</b-button>
                <b-button :disabled="disabled" class="mb-2" type="submit" variant="warning">Guardar</b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'
import PersonalSvc from '@/services/personal'
import Solicitudsvc from '@/services/solicitudes'
import CardDatosContacto from '../../common/CardDatosContacto'



import { createHelpers } from 'vuex-map-fields';


function getWeekDay() {
  const hoy = new Date();
  const dayOfTheWeek = hoy.getDay();
  console.log('hoy',  hoy.getDate(), dayOfTheWeek);
  const newDate = dayOfTheWeek === 6 ? hoy.setDate(hoy.getDate() + 2) : dayOfTheWeek === 0  ? hoy.setDate(hoy.getDate() + 1) : hoy;

  console.log('getWeekDay', (new Date(newDate)).getDate());
  return new Date(newDate);
}
const { mapFields: mapFormSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});

export default {
  name: "RegistrarSolicitudForm",
  mixins: [errorhandler, swalerts],
  components: { CardDatosContacto },
  computed: {
    ...mapGetters(['getEstablecimiento','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico']),
    ...mapFormSolicitudFields(['explicacionArticulo','TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaCargoPersonalSeleccionado']),
    DisplayPersonal: function () {
      return (this.personal ? this.personal.InformacionPersonal ? this.personal.InformacionPersonal.DisplayDniNombre : 'NULL' : 'NULL');
    },
    DisplayCargoPersonal: function () {
      var cargosSeleccionados = [];
      if(this.cargopersonal){
        this.cargopersonal.forEach(cp => {
          if(this.ListaCargoPersonalSeleccionado.indexOf(cp.Id) >= 0 ){
            cargosSeleccionados.push(cp);
          }
        });
      }
      return cargosSeleccionados;
    }
  },
  props: {
    personal: Object,
    cargopersonal: Array
  },
  watch: {
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th 6 months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 6);
    minDate.setDate(15);
    // 15th in 6 months
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 6);
    maxDate.setDate(15);
    return {
      disabled: false,
      inputFechaDesde: {
        value: getWeekDay(),
        min: minDate,
        max: maxDate
      },
      inputTipoSolicitudSelected: null,
      inputTipoContagioSelected: null,
      inputTipoSolicitud: {
        options: [
          { value: null, text: 'Seleccionar el tipo de solicitud' },
          { value: 0, text: 'Medica' },
          { value: 1, text: 'Accidente'},
          // { value: 2, text: 'Covid'},
          //{ value: 3, text: 'Vacaciones'},
          { value: 4, text: 'Artículo 17'},
          { value: 10, text: 'Artículo 20 a'},
          { value: 11, text: 'Artículo 20 b'},
          { value: 12, text: 'Artículo 20 c'},
          { value: 5, text: 'Artículo 30'},
          { value: 6, text: 'Artículo 32'},
          { value: 7, text: 'Artículo 33'},
          { value: 13, text: 'Artículo 27'},
          { value: 8, text: 'Artículo 28'},
          { value: 9, text: 'Artículo 14ext'},
          { value: 14, text: 'Artículo 48'}
        ]
      },
      inputTipoContagio: {
        options: [
          { value: null, text: 'Seleccionar el tipo de contagio' },
          { value: 0, text: 'Sintomas'},
          { value: 1, text: 'Contacto estrecho'},
          { value: 2, text: 'Positivo'},
          { value: 3, text: 'Post contagio'},
        ]
      },
      inputCantidadDias: null,
      inputAdjunto: null,
      inputObservaciones: null,
      inputFechaActual: null,
      archivoPesoAdvetencia: false,
    }
  },
  watch: {
    checkedItems(a, b) {
      this.allSelected = (this.datosDocente.length === a.length) ? true : false;
    },
    inputAdjunto: function (val) {
      if (val) {
        if (val.size > 1024 * 1024) {
          this.archivoPesoAdvetencia = true;
        } else {
          this.archivoPesoAdvetencia = false;
        }
      }
    }
  },
  mounted(){
  },
  methods: {
    // dateDisabled(ymd, date) {
    //   const weekday = date.getDay()
    //   return weekday === 0 || weekday === 6
    // },
    checkForm: function({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      console.log('onSubmit');
      this.crearSolicitudMedica();
    },

    findLicenciaCargoPersonal() {
      return LicenciaCargoPersonalSvc.findl({
        Personal_Id: this.id,
        IncluyeCargoPersonal: true,
        IncluyeUsuarioCarga: true
      });
    },


    limpiar: function() {
      this.panelDatosPersonales=false;
      this.msjCargoNoEncontrado=false;
      this.datosDocente = [];
      this.cantDiasSinTrabajar = 0;
    },

    toggleSelected() {
      this.checkedItems = this.selectAll ? this.cargosSeleccionados : [];
    },

    select() {
      if (!this.selectAll) {
        for (let i in this.datosDocente) {
          this.cargosSeleccionados.push(this.items[i].id);
        }
      }
    },

    obtenerFechaHasta() {
      var fechaRetornada = moment(this.inputFechaActual).add(this.txtCantidadDias, 'days').subtract(1, 'days').format();
      return fechaRetornada;
    },

    porcentajeDias() {
      return this.diasSinTrabajar;
    },
    cantDiasAnio() {
      return 365
    },
    calcularTipoSolicitudLicencia(tipoSolicitudMedica) {
      console.log('calcularTipoSolicitudLicencia', tipoSolicitudMedica);
      switch (tipoSolicitudMedica) {
        case 0:
        case 1:
        case 2:
        case 9:
          return 0;
        case 4:
        case 5:
        case 10:
        case 11:
        case 12:
          return 2;
        case 6:
        case 7:
        case 8:
        case 13:
          return 1;
        default:
          return -1;
      }
    },
    crearSolicitudMedica(){
      //this.desactivarBoton();
      this.disabled = true;

      this.inputFechaActual = moment();
      let formData = new FormData();
      formData.append("file", this.inputAdjunto);
      formData.append("serverpath", "solicitudlicencia");
      let filenameComprobante = this.inputAdjunto ? this.inputAdjunto.name : "";
      let comprobantename = `${moment().format("YYYYMMDDHHmmss")}_${filenameComprobante}`;
      formData.append("filename", comprobantename);
      return Solicitudsvc.crear({
        uploadfile: this.inputAdjunto ? true : false,
        formdata: formData,
        EstadoSolicitudMedica: 1,
        Fecha: this.inputFechaActual.format('YYYY-MM-DDTHH:mm:ss'),
        FechaDesde: this.inputFechaDesde.value,
        FechaHasta: this.inputFechaDesde.value,
        FechaPresentacion:this.inputFechaActual.startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        Observaciones: this.inputObservaciones,
        TipoSolicitudMedica: this.inputTipoSolicitudSelected,
        TipoSolicitudLicencia: this.calcularTipoSolicitudLicencia(this.inputTipoSolicitudSelected),
        TipoContagio: this.inputTipoContagioSelected,
        Personal_Id: this.personal.Id,
        unidadeducativa_id: this.getEstablecimiento.UnidadEducativa_Id,
        nivelenseñanza_id: this.getEstablecimiento.NivelEnseñanza_Id,
        UnidadAdministrativa_Id: this.getEstablecimiento.UnidadAdministrativa_Id,
        ListaCargoPersonal_Id: this.ListaCargoPersonalSeleccionado.slice(),
        CantidadDias: this.inputCantidadDias
        //tipolicencia_id: this.TipoLicencia ? this.TipoLicencia.Id : null,
        //detallediaslicencia_id: this.DetalleDiasLicencia ? this.DetalleDiasLicencia.Id : null
      }).then(r => {
        console.log('result crear', r);
        this.disabled = false;

        this.cerrarFormulario(r.data.status.mensaje);
      }).catch(e => {
        console.log('error crear', e);
        this.disabled = false;
        this.errorHandler(e);
      });
    },
    modalAgregarCargo(item, index, button) {
      console.log('item ',item);
      console.log('index ', index);
      this.listacargosagregar = [];
      Solicitudsvc.get({id: item.Id, incluyecargopersonal:true}).
      then(e => {
        console.log(e);
        this.solicitudseleccionada = e.data.objeto;
        this.solicitudseleccionada.ListaCargoPersonalSeleccionado.forEach(obj => {
          console.log('obj: ', obj);
          this.datosDocente.forEach(elem => {
            console.log(elem);
            var cargoagregar = elem;
            cargoagregar.activo = false;
            cargoagregar.antiguedad = (moment().diff(elem.FechaDesde, 'years', false)) + ' años';
            if(elem.Id === obj.Id){
              cargoagregar.activo = true;
            }
            this.listacargosagregar.push(elem);
          });
        });
      });

      this.$root.$emit('bv::show::modal', 'agregarCargoMOD', button);
    },
    cerrarFormulario(mensaje){
      this.limpiarFormulario();
      this.$emit('form-solicitud-close', mensaje);
    },
    limpiarFormulario()
    {
      this.ListaCargoPersonalSeleccionado = [];
      this.TipoLicencia = null;
      this.DetalleDiasLicencia = null;
      this.inputCantidadDias = null;
      this.inputAdjunto = null;
      this.inputObservaciones = null;
      this.inputFechaActual = null;
      this.inputFechaDesde.value = new Date();
      this.inputTipoSolicitudSelected = null;
      this.inputTipoContagioSelected = null;
    },
  }
}
</script>

<style >
.invalid-feedback {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/RegistrarSolicitudForm.vue